import { TableLayout } from "@/components/layout";
import { DateFormat } from "@/utils";
import { ChevronRight } from "@mui/icons-material";
import { Box, Drawer, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import RentalInsuranceForm from "./RentalInsuranceForm";
import { useState } from "react";
import { DEFAULT_PADDING } from "@/constant";
import { UseRentalInsurance } from "@/hooks";
import RentalInsuranceTableHeader from "./RentalInsuranceTableHeader";
import moment from "moment";
import { RentalInsurance } from "@/types";

interface Props {
  useRentalInsuranceInstance: UseRentalInsurance;
  propertyId: string;
}

const RentalInsuranceList = ({ useRentalInsuranceInstance, propertyId }: Props) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [selectedRentalInsurance, setSelectedRentalInsurance] = useState<RentalInsurance>(null);

  function handleClick(row: RentalInsurance) {
    setDrawerOpen(true);
    setSelectedRentalInsurance(row);
  }

  const { propertyRentalInsurance } = useRentalInsuranceInstance;
  return (
    <>
      <TableLayout
        maxHeight="70vh"
        title={
          <RentalInsuranceTableHeader
            title="Rental Insurance"
            propertyId={propertyId}
            useRentalInsuranceInstance={useRentalInsuranceInstance}
          />
        }
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Account Number</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>Link to Policy</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {propertyRentalInsurance.map((row) => (
              <TableRow tabIndex={0} sx={{ width: "100%" }} hover key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.accountNumber}</TableCell>
                <TableCell>{moment(row.startDate).format(DateFormat.DISPLAY_DATE_RANGE)}</TableCell>
                <TableCell>{row?.endDate ? moment(row.endDate).format(DateFormat.DISPLAY_DATE_RANGE) : ""}</TableCell>
                <TableCell>{row?.linkToPolicy ?? ""}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => handleClick(row)}>
                    <ChevronRight />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableLayout>
      <Drawer
        anchor="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        PaperProps={{
          sx: {
            width: 600,
          },
        }}
      >
        <Box sx={{ padding: DEFAULT_PADDING }}>
          <RentalInsuranceForm
            propertyId={propertyId}
            useRentalInsuranceInstance={useRentalInsuranceInstance}
            rentalInsurance={selectedRentalInsurance}
            close={() => setDrawerOpen(false)}
          />
        </Box>
      </Drawer>
    </>
  );
};

export default RentalInsuranceList;
